import { render, staticRenderFns } from "./ClientsOperations.vue?vue&type=template&id=3cee9474&"
import script from "./ClientsOperations.vue?vue&type=script&lang=js&"
export * from "./ClientsOperations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports